export default {
  sm: `
  CLOUD allows you efficient 
  storage and use of data for 
  both cost and technology-
  wise. NAVER CLOUD PLATFORM provides you 
  infinite possibilities.    
  `,
  md: `
  CLOUD allows you efficient storage and use of data for 
  both cost and technology-wise. NAVER CLOUD PLATFORM
  provides you infinite possibilities.      
  `,
  lg: `
  CLOUD allows you efficient storage and use of data for both 
  cost and technology-wise. NAVER CLOUD PLATFORM
  provides you infinite possibilities.      
  `,
  xxl: `
  CLOUD allows you efficient storage and use of data
  for both cost and technology-wise. NAVER CLOUD PLATFORM
  provides you infinite possibilities.      
  `,
};
